import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, BrainIcon, ZapIcon, ActivityIcon } from 'lucide-react';
const features = [{
  icon: BookOpenIcon,
  title: '60-Page Strategic Manual',
  description: 'The blueprint to rewire your neural pathways, master circadian rhythms, and eliminate fatigue at the source.'
}, {
  icon: BrainIcon,
  title: 'Neuro-Clarity Protocols',
  description: 'Step-by-step frameworks to trigger flow state on command and sustain 10+ hours of cognitive output.'
}, {
  icon: ZapIcon,
  title: 'Dopamine Deep-Clean',
  description: 'A scientific reset to kill cheap stimulation, reclaim your motivation, and stop the mindless scroll.'
}, {
  icon: ActivityIcon,
  title: 'Hormonal Baseline Reset',
  description: "Natural strategies to optimize your internal drive and recover the 'edge' modern living has stripped away."
}];
export function ProductShowcase() {
  return <section className="py-24 px-4" data-id="element-81" data-mp="24a5u0qvnhiin">
      <div className="max-w-5xl mx-auto" data-id="element-82" data-mp="2494bk1cb1tqw">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-83" data-mp="24cjp2zqbyuq7">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-84" data-mp="2i7ui07l0l5rx">
            The Biologic Edge: <br data-id="element-85" data-mp="1ll938wzgp856" />
            <span className="text-green-400" data-id="element-86" data-mp="1lhl7rsagibnt">
              Your Command Manual for the Rest of 2026
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-87" data-mp="1uk4amce8soa2">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-900/80 border border-white/10 p-8 rounded-2xl hover:border-green-500/30 transition-colors group" data-id="element-88" data-mp="1zc4e2etitzbe" data-mpi={index}>
              <div className="bg-green-500/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:bg-green-500/20 transition-colors" data-id="element-89" data-mp="2juphjbpww7pm">
                <feature.icon className="w-8 h-8 text-green-400" data-id="element-90" data-mp="1r61ouv2u2g21" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-91" data-mp="1m89wy126utxu">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-92" data-mp="207roupas6nbf">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}